/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './useStyles';
import useCommonStyles from '../../useStyles';
import { measureStyleType } from '../../../../constants/enums';
import Typography from '../../../../components/Typography/Typography';
import Grid from '../../../../components/Grid/Grid';
import { getSpec } from '../../../../Utils/measureSpecUtils';

const NMeasureStyle = ({ specSettings, measureConfig, diffNLMeasure }) => {
  const NSpec = getSpec(specSettings, measureStyleType.N).toString();
  const diffNSpec = getSpec(specSettings, measureStyleType.N, diffNLMeasure, true).toString();
  const coilSpec = getSpec(specSettings, measureStyleType.COIL).join(' / ');
  const diffCoilSpec = getSpec(specSettings, measureStyleType.COIL, measureConfig, true).join(
    ' / '
  );
  const { classes } = useStyles();
  const commonClasses = useCommonStyles().classes;

  return (
    <Grid container className={`${commonClasses.table_header} ${classes.measure_header}`}>
      {NSpec && (
        <Typography variant="subtitle1" className={classes.measure_info}>
          <b>N設定：</b>
          <b>{NSpec}</b>
          {diffNSpec && NSpec !== diffNSpec && (
            <>
              <br />
              <b style={{ opacity: 0 }}>N設定：</b>
              <b className={classes.measure_info_disabled}>{diffNSpec}</b>
            </>
          )}
        </Typography>
      )}
      {coilSpec && (
        <Typography variant="subtitle1" className={classes.measure_info}>
          <span>線圈設定：</span>
          <i>{coilSpec}</i>
          {diffCoilSpec && diffCoilSpec !== coilSpec && (
            <>
              <br />
              <span style={{ opacity: 0 }}>線圈設定：</span>
              <i className={classes.measure_info_disabled}>{diffCoilSpec}</i>
            </>
          )}
        </Typography>
      )}
    </Grid>
  );
};

NMeasureStyle.propTypes = {
  specSettings: PropTypes.object.isRequired,
  measureConfig: PropTypes.array.isRequired,
  diffNLMeasure: PropTypes.array.isRequired,
};

export default NMeasureStyle;
